import {type ComponentPropsWithoutRef, type FC} from 'react';

import {twx} from '@/utils/tailwindUtils';

interface IProgressCollapsedDotsProps extends ComponentPropsWithoutRef<'div'> {
    dotClassName?: string;
    dotCount?: number;
}

export const ProgressCollapsedDots: FC<IProgressCollapsedDotsProps> = ({
    className,
    dotClassName,
    dotCount = 3,
    ...props
}) => {
    return (
        <div
            className={twx(
                'flex flex-row items-center justify-center gap-0.5 rounded-full bg-primary-dark-25 p-1',
                className
            )}
            {...props}
        >
            {Array.from({length: dotCount || 3}).map((_, index) => (
                <div key={index} className={twx('h-1 w-1 rounded-full bg-primary-dark', dotClassName)} />
            ))}
        </div>
    );
};
